import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center bg-linen px-6" data-testid="payment-cancel">
      <Seo title="Checkout Cancelled | Psalm 30:2 Chiropractic" />
      <div className="max-w-md text-center">
        <h1 className="font-serif text-4xl text-espresso">No charge made</h1>
        <p className="text-espressosoft/75 mt-4">Your checkout was cancelled and you haven't been charged. Whenever you're ready, your plan will be waiting.</p>
        <Link to="/memberships" className="mt-8 inline-block bg-espresso text-ivory rounded-full px-8 py-3.5 text-xs uppercase tracking-[0.2em] hover:bg-brass transition-colors" data-testid="payment-cancel-back">
          Back to Memberships
        </Link>
      </div>
    </div>
  );
}
